// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__e8rUW","accent":"Button_accent__USLoT","success":"Button_success__znn7N","dimmed":"Button_dimmed__xAncT","white":"Button_white__4H6Xn"};